import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Checkbox } from 'advenio-components'
import PropTypes from 'prop-types'
import { Form } from 'formsy-react' // eslint-disable-line
import NotificationsActions from '../../../Data/Redux/NotificationsRedux'

import ProfileHeader from '../../ProfileHeader'

const Container = styled.div`
  padding: 8px;
`

const Info = styled.div`
  font-size: 12px;
  padding: 16px;
`

const NotificationsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 16px;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    flex-direction: column;
  }
`

class Notifications extends Component {
  state = {
    allNotifications: [],
  }

  componentDidMount = () => {
    const { notification_types, disabledNotifications } = this.props
    const notifications = notification_types.map((notification) => {
      if (disabledNotifications.indexOf(notification.id) < 0) {
        return {
          ...notification,
          active: true,
        }
      }
      return {
        ...notification,
        active: false,
      }
    })
    this.setState({ allNotifications: notifications })
  }

  handleSubmit = (data) => {
    const { updateNotifications, activeStudent, updateParentNotifications } = this.props
    const checkboxes = Object.keys(data)
    const active_notifications = checkboxes.filter(checkbox => data[checkbox])
    if (this.props.parent) {
      updateParentNotifications(this.props.id, { active_notifications })
    } else {
      updateNotifications(activeStudent, { active_notifications })
    }
  }

  renderNots = () => this.state.allNotifications.map(not => (
    <Checkbox
      name={String(not.id)}
      label={not.name}
      value={not.active}
      key={`${not.id}${not.name}`}
      large
      invertedColors
      hideEmptyHelpBlock
    />
  ))

  render() {
    return (
      <Container>
        <Form onSubmit={this.handleSubmit}>
          <ProfileHeader
            header="Notificaciones"
            submit
            loading={this.props.parent && this.props.loading}
            disabled={Boolean(this.props.isDisenrolled)}
          />
          <Info>Configura el tipo de notificaciones que llegarán por correo.
            Estas configuraciones aplican para todos los tutores de este alumno.</Info>
          <NotificationsContainer>
            {this.renderNots()}
          </NotificationsContainer>
        </Form>
      </Container>
    )
  }
}

Notifications.propTypes = {
  parent: PropTypes.bool,
  loading: PropTypes.bool,
  notification_types: PropTypes.array.isRequired,
  updateNotifications: PropTypes.func.isRequired,
  activeStudent: PropTypes.number.isRequired,
  updateParentNotifications: PropTypes.func.isRequired,
  disabledNotifications: PropTypes.array,
}

Notifications.defaultProps = {
  parent: false,
  loading: false,
  disabledNotifications: [],
}

const mapStateToProps = state => ({
  response: state.notifications_types.updateResponse,
  activeStudent: state.classrooms.activeStudentId,
  notification_types: state.notifications_types.get.results,
  loading: state.notifications_types.sending.fetching,
})


const mapDispatchToProps = dispatch => ({
  updateNotifications: (studentId, activeNotifications) =>
    dispatch(NotificationsActions.updateNotificationsRequest(studentId, activeNotifications)),
  updateParentNotifications: (studentId, activeNotifications) =>
    dispatch(NotificationsActions.updateParentNotificationsRequest(studentId, activeNotifications)),
})
export default connect(mapStateToProps, mapDispatchToProps)(Notifications)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Notifications/index.jsx